import {debounce} from "./helpers";

class Header {
    constructor(header) {
        this.header = header;
        this.headerToggleBtn = header.querySelector('.header__toggle');
        this.headerNav = header.querySelector('.header__nav');
        this.headerBottomRight = header.querySelector('.header-bottom__right');

        this.banner = header.querySelector('.header-banner');
        this.headerContainer = header.querySelector('.header__container');
        this.siteContentWrapper = document.querySelector('.site-content');

        this.scrollPosition = 0;
        this.isDisabledScroll = false;
        this.isMobileMenuOpen = false;
        this.resets = [];

        this.viewportWidth = null;
    }

    setBannerPadding() {
        this.siteContentWrapper.style.paddingTop = `${this.banner.offsetHeight}px`;
    }

    disableScroll() {
        this.scrollPosition = window.scrollY;
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.classList.add('disable-scroll');
        this.isDisabledScroll = true;
    }

    enableScroll() {
        document.body.style.removeProperty('top');
        document.body.classList.remove('disable-scroll');
        window.scrollTo(0, this.scrollPosition);
        this.isDisabledScroll = false;
    }

    updateMobileMenuOffset() {
        this.headerBottomRight && (this.headerBottomRight.style.top = `${this.header.offsetHeight}px`);
    }

    removeActiveDropdown(index) {
        this.resets[index].node.classList.remove('open');
        const children = this.resets[index].node.querySelector('[data-depth].open');
        if (children) {
            const childIndex = this.resets.findIndex(el => el.node === children);
            if (childIndex !== -1) {
                this.resets[childIndex].node.classList.remove('open');
                this.resets.splice(childIndex, 1);
            }
        }
        this.resets.splice(index, 1);
    }

    addActiveDropdown(dropdown) {
        if (!dropdown) return;
        dropdown.classList.add('open');
        this.resets.push({
            node: dropdown,
            class: 'open',
        });
    }

    handleToggleBurger() {
        this.header.classList.toggle('menu-open', !this.isMobileMenuOpen);
        this.headerNav.classList.toggle('open', !this.isMobileMenuOpen);
        if (!this.isMobileMenuOpen) {
            this.disableScroll();
            this.resets.push({
                node: this.header,
                class: 'menu-open',
            });
            this.resets.push({
                node: this.headerNav,
                class: 'open',
            });
        } else {
            this.enableScroll();
            this.handleClearResets();
        }
        this.updateMobileMenuOffset();
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
    }

    handleToggleDropdown(dropdown) {
        if (!dropdown) return;

        const dropIndex = this.resets.findIndex(el => el.node === dropdown);

        if (dropIndex !== -1) {
            this.removeActiveDropdown(dropIndex);
        } else {
            const levelNeighbour = this.resets.findIndex(el => el.node.dataset.depth === dropdown.dataset.depth);
            if (levelNeighbour !== -1) {
                this.removeActiveDropdown(levelNeighbour);
            }
            this.addActiveDropdown(dropdown);
        }
    }

    handleClearResets() {
        if (this.resets.length === 0) return;
        this.resets.forEach(reset => reset.node.classList.remove(reset.class));
        this.resets = [];
    }

    headerScrollHandler() {
        this.header.classList.toggle('scrolled', window.scrollY > (this.header.offsetHeight / 2));
    }

    headerResizeHandler() {
        if (this.viewportWidth === window.innerWidth) return;
        this.viewportWidth = window.innerWidth;

        this.handleClearResets();
        this.isDisabledScroll && this.enableScroll();
        this.isMobileMenuOpen = false;

        this.banner && this.setBannerPadding();
        this.updateMobileMenuOffset();
    }

    handleRemoveBanner() {
        this.banner.remove();
        document.body.removeAttribute('data-banner');
        this.header.classList.remove('hasBanner');
        this.headerContainer.classList.remove('isBanner');
        this.siteContentWrapper.style.paddingTop = `0`;
        this.updateMobileMenuOffset();
    }

    clickHandler(e) {
        if (e.target.closest('.header__toggle')) {
            this.handleToggleBurger();
        } else if (e.target.closest('.header-banner__btn')) {
            this.handleRemoveBanner();
        } else if (this.isMobileMenuOpen) {
            const dropDown = e.target.closest('li.item-with-dropdown');
            dropDown && this.handleToggleDropdown(dropDown);
        }
    }

    focusHandler(e) {
        const focusedElement = e.target.closest('[data-depth]');
        if (focusedElement && focusedElement.dataset.depth === '0' && this.resets.length > 0 && this.resets.find(el => el.node.dataset.depth === '0')) {
            this.handleClearResets();
        }
    }

    init() {
        this.viewportWidth = window.innerWidth;

        this.header.addEventListener('click', (e) => this.clickHandler(e));

        this.header.addEventListener('focus', (e) => {
            if (!this.isMobileMenuOpen) {
                this.focusHandler(e);
            }
        }, true);

        window.addEventListener('scroll', debounce(() => this.headerScrollHandler(), 20));

        window.addEventListener('resize', debounce(() => this.headerResizeHandler(), 300));

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.resets.length > 0) {
                this.handleClearResets();
            } else if (e.key === ' ') {
                const dropdown = document.activeElement.closest('li.item-with-dropdown');
                if (dropdown) {
                    e.preventDefault();
                    this.handleToggleDropdown(dropdown);
                }
            }
        });

        if (this.banner) this.setBannerPadding();
    }
}

export default Header;



// WEBPACK FOOTER //
// ./scripts/modules/header.js